// Types for the display-only MCP directory admin endpoints (symone-v2 Feature B, D22).
// They follow the typed `McpDirectoryEntry` / `McpDirectoryEntryAdmin` schemas and the
// PUT /admin/directory/mcp/{slug} request body in gateway/openapi.yaml.

/** openapi.yaml `AuthKind`: how a credential is supplied. */
export type AuthKind = 'none' | 'api_key' | 'oauth'
/** openapi.yaml `ConnectorSource`: where a connector's tools come from. */
export type ConnectorSource = 'builtin' | 'openapi' | 'mcp_upstream'
export type DirectoryStatus = 'draft' | 'active' | 'retired'

/** openapi.yaml `McpDirectoryEntry` (public shape). */
export interface DirectoryEntryPublic {
  slug: string
  name: string
  mcp_url: string
  /** The VENDOR's auth kind as entered by the admin. */
  auth_kind: AuthKind
  /** Display grouping slug (NOT the tool-category vocabulary); null = uncategorised. */
  category: string | null
  /** The vendor runs this MCP server itself. */
  official: boolean
  setup_steps_md: string
  vendor_url: string | null
  /** The Symone connector that proxies this vendor, when one exists. */
  connector_name: string | null
  /** The linked connector's source; null when no connector is linked. */
  connector_source: ConnectorSource | null
  /** The linked connector's auth kind; null when unlinked or not derivable. */
  connector_auth_kind: AuthKind | null
  updated_at?: string
}

/** openapi.yaml `McpDirectoryEntryAdmin` (GET /admin/directory/mcp entries). */
export interface DirectoryEntry extends DirectoryEntryPublic {
  status: DirectoryStatus
  created_at?: string
  updated_by?: string | null
}

/** PUT /admin/directory/mcp/{slug} response. */
export interface DirectoryEntryWrite extends DirectoryEntry {
  created: boolean
}

/** PUT /admin/directory/mcp/{slug} body (additionalProperties: false — slug is in the path). */
export interface DirectoryEntryBody {
  name: string
  mcp_url: string
  auth_kind: AuthKind
  category: string | null
  official: boolean
  setup_steps_md: string
  vendor_url: string | null
  status: DirectoryStatus
  connector_name: string | null
}

export interface DirectoryListing {
  entries: DirectoryEntry[]
}

/** Same pattern the server enforces on `category` (migration 026). */
export const DIRECTORY_CATEGORY_RE = /^[a-z][a-z0-9_]{1,31}$/
export const DIRECTORY_SLUG_RE = /^[a-z0-9][a-z0-9-]{0,63}$/
export const DIRECTORY_QUERY_KEY = ['admin-mcp-directory'] as const
